import { sourceEditorToggleText as text } from './source-editor-toggle.text.js';
import { element } from './dom.js';
import { loadSourceEditor } from './source-editor-loader.js';
import type { SourceEditorAccess } from './source-editor.js';

/** Keeps the existing textarea draft authoritative and releases hidden editors. */
export function sourceEditorToggle(textarea: HTMLTextAreaElement, filename: string) {
  const details = element('details', 'source-editor-toggle');
  const summary = element('summary', '', text.useEditor);
  const status = element('p', 'muted');
  const host = element('div', 'source-editor-host'); host.style.height = '300px'; host.style.minWidth = '0';
  details.append(summary, status, host, element('p', 'muted', text.templateOnly));
  let editor: SourceEditorAccess | undefined, epoch = 0;
  const close = () => { epoch++; editor?.dispose(); editor = undefined; textarea.hidden = false; };
  const open = async () => {
    if (!details.open || textarea.disabled || editor) return;
    const request = ++epoch; status.textContent = text.loading;
    try {
      const loaded = await loadSourceEditor(host, { value: textarea.value, filename, readOnly: false, changed: value => { textarea.value = value; } });
      if (request !== epoch || !details.open || !textarea.isConnected) { loaded.dispose(); return; }
      loaded.replace(textarea.value); editor = loaded; textarea.hidden = true; status.textContent = text.notRun;
    } catch (error) { if (request === epoch) status.textContent = error instanceof Error ? error.message : text.loadFailed; }
  };
  details.addEventListener('toggle', () => { if (details.open) void open(); else close(); });
  // The editor is released when its dialog closes.
  queueMicrotask(() => textarea.closest('dialog')?.addEventListener('close', () => { close(); details.open = false; }, { once: true }));
  return {
    element: details,
    ready: () => { if (details.open) void open(); },
    insert: (value: string) => { if (editor) editor.insert(value); else { textarea.setRangeText(value, textarea.selectionStart, textarea.selectionEnd, 'end'); textarea.focus(); } },
  };
}
